export default "__VITE_ASSET__HQZ4aYz9__"